
<script setup>

  import { useMediaQuery } from '@vueuse/core';

  import { MagnifyingGlassIcon, ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import SimpleDialog from '../dialogs/simple.vue';

  import backgroundPath from '../images/wood-background.jpg';

  const aboveSmall = useMediaQuery( '(min-width: 768px)' );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <div class="flex flex-col xl:flex-row justify-center gap-12 xl:gap-20 px-6 py-12">

        <div class="flex items-center justify-center">

          <div class="w-full max-w-xl">

            <h2 class="pb-6 border-b-[3px] border-black">

              <div class="text-xl tracking-narrow font-semibold uppercase">Step 1</div>

              <div class="text-4xl md:text-5xl font-heading uppercase">Review Example Signage</div>

            </h2>

            <p class="mt-8">
              
              Here are examples of other National Park Service displays.

              These displays are also called 'panels'.

              Click on an image to zoom in.

            </p>

            <div class="flex flex-wrap justify-between gap-6 mt-12 xl:mt-24">

              <RouterLink
              
                class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-neutral-600 transition-colors
                
                  hover:bg-neutral-700 focus-visible:bg-neutral-700 hover:underline focus-visible:underline"

                to="/activity/5/intro">
                
                <ArrowLeftCircleIcon class="w-8" />

                <span>Back</span>
              
              </RouterLink>

              <RouterLink

                class="inline-flex items-center gap-4 px-6 py-4 text-white font-bold text-white bg-green-700 transition-colors
                
                  hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
              
                to="/activity/5/step/2">
                
                <span>Next</span>

                <ArrowRightCircleIcon class="w-8" />
              
              </RouterLink>

            </div>

          </div>

        </div>

        <div class="grid md:grid-cols-3 items-center md:max-w-2xl md:my-16 xl:my-0">

          <SimpleDialog title="What's Special About Shenandoah" class="max-w-6xl">

            <template #default>

              <img class="w-full" src="../images/activity-5-step-1-sign-1.jpg" alt="Panel titled What's Special about Shenandoah, with five photos and five sections including information about Skyline Drive, Wilderness, History, Big Meadows, Appalachian Trail, and Views." draggable="false" />

            </template>

            <template #button="{ open }">

              <button class="relative w-full md:-translate-y-12 md:scale-110 border border-white shadow-[0_0_5px_0_#999]"
              
                @click="open" :disabled="! aboveSmall">

                <img class="w-full" src="../images/activity-5-step-1-sign-1.jpg" alt="" draggable="false" aria-hidden="false" />

                <div class="hidden md:block absolute bottom-2 left-2 p-2 bg-white shadow-sm">

                  <MagnifyingGlassIcon class="w-6" />

                  <span class="sr-only">Open panel 1.</span>

                </div>

              </button>
              
            </template>
            
          </SimpleDialog>

          <SimpleDialog title="Lewis Mountain Dilemma" class="max-w-6xl">

            <template #default>

              <img class="w-full" src="../images/activity-5-step-1-sign-2.jpg" alt="Panel titled Lewis Mountain Dilemma, with two bodies of text titled 'Laws and generally accepted customs,' and 'It was a hopping joint!' Ten historic photos are placed throughout." draggable="false" />

            </template>

            <template #button="{ open }">

              <button class="relative w-full md:translate-y-12 md:scale-110 z-10 mt-8 md:mt-0 border border-white shadow-[0_0_5px_0_#999]"
              
                @click="open" :disabled="! aboveSmall">

                <img class="w-full" src="../images/activity-5-step-1-sign-2.jpg" alt="" draggable="false" aria-hidden="false" />

                <div class="hidden md:block absolute bottom-2 left-2 p-2 bg-white shadow-sm">

                  <MagnifyingGlassIcon class="w-6" />

                  <span class="sr-only">Open panel 2.</span>

                </div>

              </button>

            </template>

          </SimpleDialog>

          <SimpleDialog title="The Greatest Single Feature" class="max-w-6xl">

            <template #default>

              <img class="w-full" src="../images/activity-5-step-1-sign-3.jpg" alt="Panel titled The Greatest Single Feature, with a large photo of Skyline Drive on the bottom and historic Skyline Drive photos on the top left. A 'Drive the Drive' section is seen on the top right with current Skyline Drive photos." draggable="false" />

            </template>

            <template #button="{ open }">

              <button class="relative w-full mt-8 md:mt-0 md:-translate-y-12 md:scale-110 border border-white shadow-[0_0_5px_0_#999]"
              
                @click="open" :disabled="! aboveSmall">

                <img class="w-full" src="../images/activity-5-step-1-sign-3.jpg" alt="" draggable="false" aria-hidden="false" />

                <div class="hidden md:block absolute bottom-2 right-2 p-2 bg-white shadow-sm">

                  <MagnifyingGlassIcon class="w-6" />

                  <span class="sr-only">Open panel 3.</span>

                </div>

              </button>

            </template>

          </SimpleDialog>

        </div>

      </div>

    </div>

  </article>

</template>
